module.exports = __webpack_public_path__ + "static/img/4.3faa18b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/eng/4.png
// module id = inQW
// module chunks = 0